import '../sass/timeline.scss';

(() => {
    const $blocks = document.querySelectorAll('.block.timeline');

    if (!$blocks.length) return;

    $blocks.forEach($block => {
        const $timelineScroller = $block.querySelector('.timeline__timeline');
        const $timelineScrollerContainer = $block.querySelector('.timeline__timeline-container');
        const $timelinePositionScrubber = $block.querySelector('.timeline__timeline-position-scrubber');

        const initTimelineScroller = () => {
            if (!$timelineScroller || !$timelineScrollerContainer || !$timelinePositionScrubber) return;

            $timelinePositionScrubber.addEventListener('input', () => {
                console.log('input');
                $timelineScroller.scrollTo(($timelineScrollerContainer.clientWidth - $block.clientWidth) / 100 * $timelinePositionScrubber.value, 0);
            });

            $timelineScroller.addEventListener('scroll', () => {
                $timelinePositionScrubber.value = $timelineScroller.scrollLeft / ($timelineScrollerContainer.clientWidth - $block.clientWidth) * 100;
            });
        };

        initTimelineScroller();
    });
})();
